<template>
    <div class="memorial">
        <div class="memorial__wrapper" v-if="memorial">
            <div class="header">
                <span @click="getMemorial">
                    <welcome-refresh-button class="header__refresh">Обновить</welcome-refresh-button>
                </span>

                <div class="header__link-wrapper">
                    <a class="link header__link" href="/place">
                        <span>На страницу проекта</span>
                    </a>
                </div>
            </div>

            <h3 class="title title--uppercase memorial__title">{{ memorial.title }}</h3>
            <div class="memorial__main">
                <div v-if="memorial.photos[0].custom_properties.tabName === 'one'" class="gallery gallery--example gallery--one">
                    <div class="gallery__item gallery__item--one">
                        <img :src="memorial.photos[0].url" alt="img" class="gallery__img">
                    </div>
                </div>

                <div v-else-if="memorial.photos[0].custom_properties.tabName === 'two'" class="gallery gallery--example gallery--two">
                    <div class="gallery__item gallery__item--two-big">
                        <img :src="memorial.photos[0].url" alt="img" class="gallery__img">
                    </div>
                    <div class="gallery__item gallery__item--two-small">
                        <img :src="memorial.photos[1].url" alt="img" class="gallery__img">
                    </div>
                </div>

                <div v-else-if="memorial.photos[0].custom_properties.tabName === 'three'" class="gallery gallery--example gallery--three">
                    <div class="gallery__item gallery__item--three-big">
                        <img :src="memorial.photos[0].url" alt="img" class="gallery__img">
                    </div>
                    <div class="gallery__item gallery__item--three-small">
                        <img :src="memorial.photos[1].url" alt="img" class="gallery__img">
                    </div>
                    <div class="gallery__item gallery__item--three-small">
                        <img :src="memorial.photos[2].url" alt="img" class="gallery__img">
                    </div>
                </div>

                <div class="content memorial__content">
                    <div class="title title--uppercase content__title">{{ memorial.subtitle }}</div>
                    <div class="title title--s content__dates">{{ memorial.build_at }}</div>
                    <div class="content__desc" v-html="memorial.short_description"></div>
                    <div class="content__separator"></div>
                    <a target="_blank" class="link content__link" :href="link(memorial.slug)">
                        Читать историю
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../api/api";
import WelcomeRefreshButton from "./WelcomeRefreshButton.vue";
import WelcomePagesCategory from "./WelcomePagesCategory.vue";
import {mapActions, mapGetters} from "vuex";

export default {
    name: 'WelcomeMemorials',
    components: {WelcomePagesCategory, WelcomeRefreshButton},
    data() {
        return {
            domain: window.laravel.appUrlByLocale,
            locale: window.laravel.locale,
        }
    },
    mounted() {
        this.getMemorial();
    },
    computed: {
        ...mapGetters('welcome', [
            'memorial',
        ]),
    },
    methods: {
        ...mapActions('welcome', [
            'getMemorial',
        ]),
        link(slug) {
            if(this.domain && slug) {
                return this.domain + '/place/' + slug;
            } else {
                return '/place';
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
.header {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    display: none;
    @media (max-width: 1159px) {
        display: flex;
    }
}
.header__link-wrapper {
    flex: 1 1;
    display: flex;
    justify-content: flex-end;
    @media (max-width: 600px) {
        display: none;
    }
}
.header__link {

}
.memorial__wrapper {
    border-radius: 4px;
    border: 1px solid var(--unnamed, rgba(192, 201, 218, 0.31));
    background: #FFF;
    padding: 2.6rem 3.2rem 3.5rem 2.8rem;
    display: flex;
    flex-direction: column;

    @media (max-width: 1159px) {
        border-radius: 5px;
        box-shadow: 0 40px 100px 0 rgba(195, 195, 195, 0.26);
    }
}
.memorial__title {
    font-size: 28px;
    @media (max-width: 1159px) {
        display: none;
    }
}
.memorial__main {
    margin-top: 3.5rem;
    display: flex;
    align-items: stretch;
    @media (max-width: 1159px) {
        flex-direction: column;
    }
}
.content {
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    @media (min-width: 1160px) {
        max-width: calc(300px + 10rem);
        min-width: calc(300px + 10rem);
        padding: 0 4.5rem;
    }
    @media (max-width: 1159px) {
        width: 100%;
    }
}
.content__title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.2rem;
    font-weight: 700;
    @media (max-width: 1159px) {
        margin-top: 1.6rem;
    }
    @media (max-width: 560px) {
        margin-top: 2.1rem;
    }
}
.content__dates {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 0.3rem;
    font-size: 4rem;
    white-space: break-spaces;
    @media (max-width: 1159px) {
        margin-top: 0;
    }
}
.content__desc {
    width: 100%;
    flex: 1 1;
    margin-top: 1.4rem;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 140%;
    @media (max-width: 1159px) {
        margin-top: 1.6rem;
    }
    @media (max-width: 560px) {
        margin-top: 2.1rem;
        font-size: 1.6rem;
    }
}
.content__desc::v-deep p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    -moz-line-clamp: 8;
    &:not(:first-child) {
        display: none;
    }
}
.content__separator {
    width: 100%;
    height: 1px;
    background-color: #C0C9DA;
    margin-top: 2.6rem;
}
.content__link {
    margin-top: 2.7rem;
    gap: 1.5rem;
}
.gallery {
    display: grid;
    gap: 2.8rem;
    position: relative;
    &--two {
        @media (max-width: 560px) {
            grid-template-columns: 1fr;
        }
        @media (min-width: 561px) {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }
    &--three {
        @media (max-width: 560px) {
            grid-template-columns: 1fr;
        }
        @media (min-width: 561px) {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }
    &--example {
        flex-grow: 1;
        gap: 1.6rem;
    }
}
.gallery__item {
    display: block;
    position: relative;
    padding-top: 100%;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: inset 0 0 0 1px #C0C9DA;
    margin-bottom: 0 !important;
    &--one {
        padding-top: 47.3%;
    }
    &--two {
        &-big {
            padding-top: 72%;
            @media (max-width: 560px) {
                padding-top: 37%;
                grid-row: auto;
                grid-column: auto;
            }
            @media (min-width: 561px) {
                grid-column: 1/3;
            }
        }
        &-small {
            padding-top: 150%;

            @media (max-width: 560px) {
                padding-top: 37%;
                grid-row: auto;
                grid-column: auto;
            }
        }
    }
    &--three {
        &-big {
            padding-top: 72%;
            @media (max-width: 560px) {
                grid-row: auto;
                grid-column: auto;
            }
            @media (min-width: 561px) {
                grid-row: 1/3;
                grid-column: 1/3;
            }
        }
        &-small {
            padding-top: 70.5%;
        }
    }
    &--timeline {
        padding-top: 55%;
    }
    @media (max-width: 560px) {
        width: 100%;
        height: 155px;
    }
}
.gallery__img {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    object-fit: cover;
}
</style>
